import * as React from "react";
import TransitionCancelFinish from "../pages/TransitionCancelFinish";

const TransitionCancelFinishContainer = () => {
    return <TransitionCancelFinish />;
};

export default TransitionCancelFinishContainer;
